import useChangeRoute from '@shared/hooks/useChangeRoute';

const ChangePageLoader = () => {
  useChangeRoute();

  return null;
};

export default ChangePageLoader;
